import { API_URL } from './constants';
import { ApiCrmImportApolloResponse } from './types/crm';

export async function apiCrmImportApollo(
  file: File,
  token: string,
): Promise<[ApiCrmImportApolloResponse, number]> {
  const formData = new FormData();
  formData.append('file', file);

  const url = new URL(`${API_URL}/admin/crm/import-apollo`).href;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });
  return [
    (await response.json()) as ApiCrmImportApolloResponse,
    response.status,
  ];
}
